import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { RouteReuseStrategy } from '@angular/router'

import { IonicRouteStrategy } from '@ionic/angular/standalone'

import { AppComponent } from 'src/app/app.component'
import { AppRoutingModule } from 'src/app/app-routing.module'
import { Capacitor } from '@capacitor/core'
import { IconComponent } from './components/icon/icon.component'
import { DiscordService } from './services/discord/discord.service'

import { provideLottieOptions } from 'ngx-lottie'
import player from 'lottie-web'

import localeId from '@angular/common/locales/id'
import { registerLocaleData } from '@angular/common'
import { provideHttpClient } from '@angular/common/http'
import {
  IonApp,
  IonRouterOutlet,
  provideIonicAngular,
} from '@ionic/angular/standalone'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
registerLocaleData(localeId, 'id')

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    IconComponent,
    IonApp,
    IonRouterOutlet,
  ],
  providers: [
    provideIonicAngular({
      animated: Capacitor.getPlatform() === 'web' ? false : true,
    }),
    provideHttpClient(),
    provideLottieOptions({
      player: () => player,
    }),
    {
      provide: RouteReuseStrategy,
      useClass: IonicRouteStrategy,
    },
    {
      provide: LOCALE_ID,
      useValue: 'id',
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
